import * as React from "react";

const Options = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g id="g35">
      <path
        id="path39"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeDashoffset="3.477"
        strokeLinecap="round"
        strokeLinejoin="miter"
        strokeOpacity="1"
        strokeWidth="0.4"
        d="M2.646 1.587a1.058 1.058 0 1 1-2.117 0 1.058 1.058 0 0 1 2.117 0zm1.058 0a1.058 1.058 0 1 0 2.117 0 1.058 1.058 0 0 0-2.117 0zM2.646 4.762a1.058 1.058 0 1 0-2.117 0 1.058 1.058 0 0 0 2.117 0zm1.058 0a1.058 1.058 0 1 1 2.117 0 1.058 1.058 0 0 1-2.117 0z"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Options;
